export default __webpack_public_path__ + "static/media/297.73a9fde4.png";